import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantContextService } from '../tenant/tenant-context.service';

@Injectable({ providedIn: 'root' })
export class TenantInterceptor implements HttpInterceptor {
  private readonly tenant = inject(TenantContextService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const slug = this.tenant.tenantSlug();
    if (!slug) return next.handle(req);
    return next.handle(req.clone({ setHeaders: { 'X-Tenant-Slug': slug } }));
  }
}
